export enum ResetPasswordActionTypes {
    API_RESPONSE_SUCCESS = '@@resetPassword/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@resetPassword/API_RESPONSE_ERROR',

    EDIT_RESET_PASSWORD = '@@resetPassword/EDIT_RESET_PASSWORD',
    RESET = '@@resetPassword/RESET',
    RESET_SUCCESS = '@@resetPassword/RESET_SUCCESS',
    RESET_ERROR = '@@resetPassword/RESET_ERROR',
}
